export default "__VITE_ASSET__6jfAj9jh__"